export const isAdfs = (): boolean => {
  const currentUrl = window.location.href;
  const adfsUrl = process.env.REACT_APP_MIDAS_ADFS_FE_URL;
  const adfsProdUrl = process.env.REACT_APP_MIDAS_ADFS_FE_PROD_URL;

  const result =
    !!(adfsUrl && currentUrl.includes(adfsUrl)) ||
    !!(adfsProdUrl && currentUrl.includes(adfsProdUrl));

  const authProvider = window.localStorage.getItem("AUTH_PROVIDER");

  if (authProvider !== null && authProvider !== undefined) {
    window.localStorage.setItem("AUTH_PROVIDER", result ? "Adfs" : "AzureAd");
  }

  return result;
};
